module.exports = __webpack_public_path__ + "img/index_jiejue6.605416ea.png";